// extracted by mini-css-extract-plugin
export default {"header":"MainHeader_header__UuPGK","nav":"MainHeader_nav__sgJ3z","logo":"MainHeader_logo__k-hHk","active":"MainHeader_active__Gu5Oa"};